<template>
  <div class="tab-service">
    <ul class="tab-service-detail">
      <li :class="{on: status === item.key}" v-for="(item, index) in tabList" :key="index">
        <a href="javascript:void(0);" @click.stop="onShiftTab(item.key)">{{item.name}}</a>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  props: {
    tabList: {
      type: Array,
      default() {
        return []
      }
    },
    status: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    onShiftTab(key) {
      if (this.status === key) return false
      this.$emit('update:status', key)
      this.$emit('tab-change', key)
    }
  }
}

</script>
<style lang="less">
</style>
